import { SerializedData, Store } from "bernie-core";
import { Logger, NOOP_LOGGER } from "bernie-logger";
import { getBexApiContext } from "bernie-context";
import { ExtendedContextStore } from "../typings/flexFramework/FlexDefinitions";
import { CampaignByIdQuery, CampaignProductType, UserLocationInput } from "../../__generated__/api";
import { BexApiService } from "../services/BexApiService";
import { FAILED_CAMPAIGN_FETCH } from "../config/systemEvents";
import { CampaignQueryResult } from "components/flexComponents/Deals/typings";

export class DealsStore extends Store {
  public bexApiService: BexApiService;
  public referrerId: string | null | undefined;

  public constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER, bexApiService: BexApiService) {
    super(state, logger);
    this.bexApiService = bexApiService;
    this.referrerId = null;
  }

  public hydrate(data: SerializedData): void {
    // The serialized store as returned by the server exposes a stripped down
    // version of bexApiService with no methods.We delete it here to prevent the override.
    delete data.bexApiService;
    Object.assign(this, data);
  }

  public mapCampaignProductTypes(productTypes: string[]): CampaignProductType[] | [] {
    return productTypes?.map((product: string) => {
      return CampaignProductType[product];
    });
  }

  public mapUserLocationInput(userLatitude?: number, userLongitude?: number): UserLocationInput | null {
    if (userLatitude && userLatitude !== null && userLongitude && userLongitude !== null) {
      return {
        userLatitude,
        userLongitude,
      };
    }

    return null;
  }

  public async fetchCampaignDeals(
    contextStore: ExtendedContextStore,
    campaignId: string,
    enableTripAttach: boolean,
    pageNumber: number,
    pageSize?: number,
    userLatitude?: number,
    userLongitude?: number,
    displayPropertyCount?: boolean,
    pageName?: string
  ): Promise<CampaignQueryResult> {
    const variables: CampaignByIdQuery.Variables = {
      campaignId,
      enableTripAttach,
      pageNumber,
      pageSize,
      context: getBexApiContext(contextStore),
      userLocation: this.mapUserLocationInput(userLatitude, userLongitude),
      displayPropertyCount,
      referrer: this.referrerId,
    };
    try {
      const query = await this.bexApiService.fetchCampaignByIdQuery(variables);
      const traceId = query.extensions?.trace?.["Trace-ID"];
      const errorMessage = (query.errors as any)?.[0]?.message;
      const campaign = query.data.campaignRecommendations?.campaigns[0];
      this.referrerId = query.data.campaignRecommendations?.paginationInfo?.referrer;

      return { traceId, errorMessage, campaign };
    } catch (err) {
      this.logger.logEvent(FAILED_CAMPAIGN_FETCH, "Unexpected error when fetching deals campaign offers", err);

      return { errorMessage: "Unexpected error when fetching deals campaign offers" };
    }
  }
}
